import debounce from "debounce-promise";
import CategoryDropdown from "@/components/categoryDropdown/categoryDropdown.vue";
import OrderToggle from "@/components/orderToggle/orderToggle.vue";
import { REQUEST_STATE } from "@/enums";
import { SettingsService } from "@/services/settingsApi";
import { createNamespacedHelpers } from "vuex";
import addRemoveTrackedItem from "@/components/addRemoveTrackedItem/addRemoveTrackedItem.vue";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	REQUEST_DEBOUNCE_TIME = 300;

export default {
	components: {
		CategoryDropdown,
		OrderToggle,
		addRemoveTrackedItem,
	},

	props: {
		labelsToHide: {
			type: Array,
			required: true,
		},
	},

	watch: {
		query() {
			this.getOutletLabels();
		},

		selectedCategory() {
			this.getOutletLabels();
		},

		order() {
			this.getOutletLabels();
		},

		labelsToHide() {
			this.getOutletLabels();
		},
	},

	data() {
		return {
			query: "",
			selectedCategory: {
				id: null,
				en: "items.all_categories",
				de: "items.all_categories",
				fr: "items.all_categories",
			},

			/** "asc"|"desc" */
			order: "desc",

			labels: [],
			outletCategories: [],

			areOutletCategoriesSet: false,

			status: REQUEST_STATE.LOADING,
			REQUEST_STATE,

			showAddModal: false,
			labelToAdd: null,
		};
	},

	computed: { ...userGetters(["activeOutlet", "weightUnit", "weightFactor"]) },

	methods: {
		getOutletLabels: debounce(getOutletLabels, REQUEST_DEBOUNCE_TIME),
		onClickAddLabel,
		saveNewTrackedLabel,
		closeModal,
	},
};

async function getOutletLabels() {
	this.status = REQUEST_STATE.LOADING;
	this.labels = [];

	try {
		const { data } = await SettingsService.getOutletLabels({
			categoryId: this.selectedCategory.id,
			query: this.query,
			sort: this.order,
			sortBy: "last_month_weight",
		});

		this.labels.push(...data.labels);

		if (!this.areOutletCategoriesSet) {
			this.outletCategories = new Set(this.labels.map((label) => label.group.id));
			this.outletCategories = [...this.outletCategories];
			this.areOutletCategoriesSet = true;
		}

		this.labels = this.labels.filter((label) => !this.labelsToHide.includes(label.label_id));

		this.status = REQUEST_STATE.SUCCESS;
	} catch (error) {
		this.status = REQUEST_STATE.ERROR;
	}
}

function onClickAddLabel(label) {
	this.labelToAdd = {
		label_id: label.label_id,
		translations: label.description.translations,
	};
	this.showAddModal = true;
}

function saveNewTrackedLabel(labelId, date) {
	// find label in labels
	const label = this.labels.find((item) => item.label_id === labelId);
	this.$emit("add", label, date);
}

function closeModal() {
	this.showAddModal = false;
}
